module.exports = __webpack_public_path__ + "img/close.80bcc4bb.png";